import { resolveValueDisplay } from '../../../_entity/value/index.js';
//******* Atom level generic utils
export const resolveAssociatedEntity = (dbAtom, dependencies) => {
    if (dbAtom.leftHand?.type === 'expression') {
        return dependencies.expressions.find(expr => expr._id === dbAtom.leftHand?.id);
    }
    // Resolve entity from referenced variables
    return dependencies.variables.find(variable => variable._id === dbAtom.leftHand?.id);
};
export const createHVValueOption = (id, dependencies) => {
    const schemaValue = {};
    schemaValue.db_id = id;
    const value = dependencies.values.find(value => value._id === id);
    if (value)
        // FIXME: maybe we should move this function to shared
        schemaValue.value = resolveValueDisplay(value);
    return schemaValue;
};
//# sourceMappingURL=utils.js.map